





















import { Component, Mixins, Prop, } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { IRestrictions } from "./editor";
import { ExistingDocumentEditor } from "./editors/sign";
import { DocumentEditViewMixin } from "./mixins";

@Component({
  components: {
    FixedLoading,
    ExistingDocumentEditor,
    RequestedDocumentProcessor,
  }
})
export default class DocumentEditSignView extends Mixins(DocumentEditViewMixin) {
  @Prop()
  documentId: number;

  @Prop()
  orderNo: string;

  get restrictions(): IRestrictions {
    return {
      pageList: {
        isDisabled: true,
      },
    };
  }
}
